import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PartyCriteria } from '../../../model/criteria.model';

@Component({
  selector: 'party-criteria',
  templateUrl: './party-criteria.template.html',
  styleUrls: ['./party-criteria.css'],
})
export class PartyCriteriaComponent {
  @Input() partyType: string;
  @Input() party: PartyCriteria;

  @Output() onOpenHelp: EventEmitter<string> = new EventEmitter<string>();

  ngOnInit() {
  }

  constructor() {}

  openHelp(): void {
    this.onOpenHelp.emit('parties');
  }
}

